/**
 * @module ui/templates/modals/native-app-cta
 */
import tgamConfig from "config/tgam";
import { closeButton } from "ui/templates/btn";

const dismissButton = closeButton({
  id: "js-native-app-cta-modal-close"
});

export const NATIVE_APP_CTA_MODAL = `
  <div class="o-modal-container o-modal-container--logged-in">
    <div class="o-modal-row o-modal-row--blue o-modal-row--close">
      ${dismissButton}
    </div>
    <div class="o-modal-row o-modal-row--main">
      <h2 class="c-modal-header">Download our app so that you don't miss a thing.</h2>

      <div class="arc-native-app-cta-modal__image-container">
        <img class="arc-native-app-cta-modal__image" src="${tgamConfig.env.staticMediaUrl}/assets/img/tgam-apps.png?token=${tgamConfig.env.cacheToken}" alt="Globe and Mail mobile apps" />
      </div>

      <p class="c-modal-text">Download our app for free to your smartphone or tablet.</p>
      <p class="c-modal-text">Enjoy exclusive journalism, offline reading, and opt-in alerts.</p>

      <div class="c-app-download">
        <a href="https://itunes.apple.com/ca/app/the-globe-and-mail-news/id429228415?mt=8"
          class="c-app-download__link"
          aria-label="Download on the App Store"
          data-analyticsclick='{"feature": "modal-app-download", "type": "link", "action": "outbound", "label": "download on the app store"}'
          rel="external">
          <svg class="c-app-download__icon" role="img" pointer-events="none" focusable="false" aria-hidden="true">
            <use xlink:href="${tgamConfig.env.svgSpritePath}#button-applestore"></use>
          </svg>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.theglobeandmail.headliner&hl=en"
          class="c-app-download__link"
          aria-label="Get it on Google Play"
          data-analyticsclick='{"feature": "modal-app-download", "type": "link", "action": "outbound", "label": "get it on google play"}'
          rel="external">
          <svg class="c-app-download__icon" role="img" pointer-events="none" focusable="false" aria-hidden="true">
            <use xlink:href="${tgamConfig.env.svgSpritePath}#button-googleplay"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
`;
